import { Avatar, Box, Card, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import ArtPiece from "../components/ArtPiece";

const KHome = () => {
  useEffect(() => {
    document.title = "Kaylin Ackerman - Home"; // Set the page title

    // Set the favicon
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      (favicon as HTMLLinkElement).href = "/images/art3"; // Path to your favicon file
    } else {
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = "/images/art3"; // Path to your favicon file
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Box fontFamily={"Limelight"}>
      <Grid container>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "100vw",
              height: "500px",
              backgroundImage: "url('/images/background.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
              <Avatar
                src="/images/KaylinArt.jpg"
                sx={{
                  width: 200,
                  height: 200,
                  img: {
                    objectFit: "cover", // Ensures the image covers the avatar area
                    objectPosition: "100% 0%", // Centers the image within the avatar
                  },
                }}
                alt="Kaylin"
              />
              <Typography variant="h4" fontFamily={"Limelight"}>
                Kaylin Ackerman
              </Typography>
              <Card sx={{ backgroundColor: "#F2F0EF", borderRadius: 3 }}>
                <a
                  href="https://www.instagram.com/drawing.turtles"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Box p={1} alignItems={"center"} display={"flex"}>
                    <Typography color="black" variant="h6">
                      Instagram
                    </Typography>
                    <img
                      src="images/instagram2.svg"
                      alt="Instagram"
                      style={{ width: "40px", marginLeft: "10px" }}
                    />
                  </Box>
                </a>
              </Card>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            bgcolor={"#F2F0EF"}
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Box p={2}>
              <Grid container columnSpacing={2} rowSpacing={2}>
                <Grid item xs={12}>
                  <Box
                    pb={2}
                    display="flex"
                    justifyContent="center"
                    flexDirection={"column"}
                    alignItems="center"
                  >
                    <Typography color="#7ca7cf" variant="h4" fontFamily={"Limelight"}>
                      Showcased pieces
                    </Typography>
                    <Typography color="#7ca7cf" fontFamily={"Limelight"}>
                      Click on one to get a better look!
                    </Typography>
                  </Box>
                </Grid>
                <ArtPiece src="/images/Scorpion" alt="Scorpion" />
                <ArtPiece src="/images/Moon" alt="Moon" />
                <ArtPiece src="/images/Chrome" alt="Chrome" />
                <ArtPiece src="/images/Girl" alt="Girl" />

                <Grid item xs={12} display={"flex"} justifyContent="center">
                  <Box pt={4} pb={2}>
                    <Typography color="#7ca7cf" variant="h5" fontFamily={"Limelight"}>
                      Full Gallery
                    </Typography>
                  </Box>
                </Grid>
                <ArtPiece src="/images/PurpleHair" alt="PurpleHair" />
                <ArtPiece src="/images/Moth" alt="Moth" />
                <ArtPiece src="/images/LadyBug" alt="LadyBug" />
                <ArtPiece src="/images/Landscape" alt="Landscape" />
                <ArtPiece src="/images/Bee" alt="Bee" />


                <ArtPiece src="/images/Frog" alt="Frog" />
                <ArtPiece src="/images/BlueSkull" alt="BlueSkull" />
                <ArtPiece src="/images/OtherBlueSkull" alt="OtherBlueSkull" />

                <ArtPiece src="/images/BlueHair" alt="BlueHair" />

                {/* <ArtPiece src="/images/art5" alt="art5" /> */}
                {/* <ArtPiece src="/images/art6" alt="art6" /> */}
                {/* <ArtPiece src="/images/art7" alt="art7" /> */}
                <ArtPiece src="/images/art8" alt="art8" />
                <ArtPiece src="/images/art9" alt="art9" />
                <ArtPiece src="/images/art10" alt="art10" />
                <ArtPiece src="/images/art11" alt="art11" />
                <ArtPiece src="/images/art12" alt="art12" />
                <ArtPiece
                  src="/images/art1"
                  alt="art1"
                // title="Art Piece 1"
                // description="Description of Art Piece"
                />
                <ArtPiece
                  src="/images/art2"
                  alt="art2"
                // title="Art Piece 2"
                // description="Description of Art Piece"
                />
                <ArtPiece
                  src="/images/art3"
                  alt="art3"
                // title="Art Piece 3"
                // description="Description of Art Piece"
                />
                <ArtPiece
                  src="/images/art4"
                  alt="art4"
                // title="Art Piece 4"
                // description="Description of Art Piece"
                />
              </Grid>
            </Box>
          </Box>
          <Box pt={4} bgcolor={"#F2F0EF"}>
            <Typography color="#7ca7cf" variant="h5" align="center">
              For inquries about prints or commissions,
              <Box>
                please contact me at{" "}
                <a href="mailto:kaylin.ackerman2021@gmail.com" style={{ color: "#3f688f", textDecoration: "underline" }} >
                  kaylin.ackerman2021@gmail.com
                </a>
              </Box>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default KHome;
